import React, { Component } from 'react';
import { SendDocumentTemplate } from '../../Templates';
import {
  apiGetAllCategories,
  apiPostSendDocument,
  apiPostNewSendDocument,
  apiPostSendDocumentCertificates
} from '../../Api/Documents/Documents';
import { isNumber } from '../../Validation';
import getApiErrorMessages from '../../Utils/getApiErrorMessages';
import Store from '../../Redux/Store';
import moment from 'moment';
import PropTypes from 'prop-types';
import { BANETTE } from '../../Config/Config';

// Préparer le commentaire pour la médecine douce
const createMedecineDouceComment = (medicine, description, mutual) => {
  return `
    BENEFICIAIRE DU SOIN: ${medicine.benefitaire} \n
    DATE DU SOIN: ${moment(new Date(medicine.date)).format('DD/MM/YYYY')} \n
    NATURE DU SOIN: ${medicine.nature} \n
    CODE ADELI ou N° Siret: ${medicine.code} \n
    MONTANT DEPENSE : ${medicine.amount} € \n
    COMMENTAIRE: ${description} \n
    ${
      mutual.amount
        ? `MONTANT REMBOURSE PAR AUTRE MUTUELLE : ${mutual.amount} €`
        : ''
    }
    `;
};

// Préparer le commentaire pour le maintien de l enfant
const createJustificatifMaintienComment = (enfant, description) => {
  //gérer le cas undefined
  const documentRequis =
    enfant.typedoc?.docToSend ?? enfant.situation?.docToSend ?? 'Non spécifié';
  return `
    ENFANT BENEFICIAIRE : ${enfant.benefitaire.firstName} ${enfant.benefitaire.lastName} \n
    CODE ADHERENT :  : ${enfant.benefitaire.codeAdherent} \n
    NUM SS : ${enfant.benefitaire.securityNumber} \n
    DATE DE NAISSANCE :  ${enfant.benefitaire.birthDate} \n
    ANNEE SCOLAIRE: ${enfant.schoolYear} \n
    SITUATION DE L ENFANT: ${enfant.situation.situation} \n
    TYPE DE DOCUMENT REQUIS : ${documentRequis} \n
    CERTIFICATION SUR L HONNEUR : OUI \n
    COMMENTAIRE : ${description} \n
    `;
};

class SendDocument extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1,
      category: null,
      type: null,
      description: '',
      files: [],
      medicine: {
        benefitaire: '',
        date: null,
        nature: '',
        code: '',
        amount: ''
      },
      enfant: {},
      stepMedicine: 1,
      showNewMutual: false,
      mutual: { amount: '', file: null },
      remboursement: '48',
      isUploadValid: true,
      isDescriptionValid: true,
      sendDocumentErrors: [],
      data: [],
      contractTypes: Store.getState().auth.user.contractTypes,
      categoryList: [],
      selectedSeuil: 0
    };
  }

  componentDidMount() {
    this.getAllCategories();
  }
  getActionsFromFAQ(data) {
    const category = this.props.location?.state?.name;
    const page = this.props.location?.state?.page;

    const categoryElement = this.state.data.find(
      (elem) =>
        elem.name?.toLowerCase().trim() == category?.toLowerCase().trim()
    );
    const categoryId = categoryElement?.categoryId;
    const subCategory = data?.find(
      (el) => el.categoryName?.toLowerCase() === page?.toLowerCase()
    );
    this.selectCategory(
      subCategory,
      categoryElement,
      data?.filter((el) => el.parentCategoryId === categoryId),
      category
    );
  }

  getAllCategories = async () => {
    const res = await apiGetAllCategories();
    let documentsList = res.data.map((elem) => {
      return { ...elem, name: elem.categoryName, id: elem.categoryId };
    });

    if (res.status === 200) {
      this.setState({
        data: documentsList
      }, () => {
        // Gestion des paramètres existants dans location.state 
        if (this.props.location?.state?.name && this.props.location?.state?.page) {
        this.getActionsFromFAQ(this.state.data);
                } else if (this.props.location?.state?.name) {
        const subCategoryName = this.props.location?.state?.name;
          const bankElement = documentsList.find((elem) => elem.name === 'BANQUE');
          const devisElement = documentsList.find((elem) => elem.name === 'DEVIS');
        if (bankElement) {
          const categoryId = bankElement?.categoryId;
          const subCategory = documentsList?.find(
            (el) =>
              el.parentCategoryId === categoryId &&
              el.categoryName === subCategoryName
          );
          if (subCategory) {
            this.selectCategory(
              subCategory,
              bankElement,
              documentsList?.filter((el) => el.parentCategoryId === categoryId)
            );
          }
        }
        if (devisElement) {
          this.selectElement(devisElement);
        }
                } else if (this.props.location?.state?.name === 'ATTESTATION DE SECURITE SOCIALE') {
        const subCategoryName = this.props.location?.state?.name;
        const attestation = documentsList.find(
            (elem) => elem.name === subCategoryName
        );
        this.selectElement(attestation);
                } else if (this.props.location.search) {
      const queryParameters = new URLSearchParams(window.location.search);
        if (queryParameters.get('type') === 'facture') {
          let factureElem = this.state.data.find((elem) => elem.name === 'FACTURE');
          this.selectElement(factureElem);
        }

        // logique pour gérer les paramètres de l'URL
          const queryParams = new URLSearchParams(this.props.location.search);
          const categoryName = queryParams.get('category');
          const subCategoryName = queryParams.get('subCategory');

          if (categoryName && subCategoryName) {
            const categoryElement = this.state.data.find(
              (elem) => elem.name === categoryName
            );
            if (categoryElement) {
              const subCategoryElement = this.state.data.find(
                (elem) =>
                  elem.parentCategoryId === categoryElement.categoryId &&
                  elem.name === subCategoryName
              );
              if (subCategoryElement) {
                const categoryList = this.state.data.filter(
                  (elem) => elem.parentCategoryId === categoryElement.categoryId
        );
                this.selectCategory(subCategoryElement, categoryElement, categoryList);
              } else {
                console.warn(`Sous-catégorie "${subCategoryName}" non trouvée pour la catégorie "${categoryName}".`);
              }
            } else {
              console.warn(`Catégorie "${categoryName}" non trouvée.`);
            }
          }
                }      });
    }
  };

  onSelectSeuil = (selectedSeuil) => {
    this.setState({ selectedSeuil: selectedSeuil });
  };

  onReturn = () => {
    if (this.state.stepMedicine === 2) {
      this.setState({
        stepMedicine: 1,
        sendDocumentErrors: []
      });
    } else {
      if (this.state.step === 1) {
        this.props.history.push('/documents');
      } else {
        if (this.state.step == 3) {
          const contactParams = new URLSearchParams(document.location.search);
          this.props.history.push({
            pathname: '/documents/send',
            search: `?category=${contactParams.get('category')}`
          });
        } else {
          this.props.history.push('/documents/send');
        }

        this.setState({
          step:
            this.state.step === 4 ||
            (this.state.step == 3 && this.state.categoryList.length == 0)
              ? 1
              : this.state.step - 1,
          files: [],
          errorsUpload: [],
          sendDocumentIsLoading: false,
          description: '',
          isUploadValid: true,
          isDescriptionValid: true,
          sendDocumentErrors: [],
          stepMedicine: 1,
          showNewMutual: false,
          mutual: { amount: '', file: [] },
          remboursement: '48',
          medicine: {
            benefitaire: '',
            date: null,
            nature: '',
            code: '',
            amount: '',
            files: []
          },
          errorsMedecine: []
        });
      }
    }
  };

  selectElement = (value) => {
    let category = [];
    this.state.data.forEach((element) => {
      if (value.id === element.parentCategoryId) {
        category.push(element);
      }
    });

    this.setState({
      step: category?.length === 1 ? 3 : 2,
      type: value,
      stepMedicine: 1,
      showNewMutual: false,
      mutual: { amount: '', file: null },
      remboursement: '48',
      categoryList: category
    });

    this.props.history.push({
      pathname: '/documents/send',
      search: `?category=${value.name}`
    });

    if (category.length == 0 && !this.props.location?.state?.data) {
      this.selectCategory(value);
    }
    if (category.length === 1) {
      this.selectCategory(category[0]);
    }
  };

  selectCategory = (value, type, categoryList, categoryFromFAQ = null) => {
    if (
      value.categoryName === 'Ajouter un conjoint(e)' ||
      value.categoryName === 'Ajouter un enfant'
    ) {
      this.props.history.push({
        pathname: '/profile',
        state: { benefType: value.categoryName }
      });
      return;
    }
    const contactParams = new URLSearchParams(document.location.search);
    const category =
      categoryFromFAQ != null ? categoryFromFAQ : contactParams.get('category');
    this.props.history.push({
      pathname: '/documents/send',
      search: `?category=${category}&subCategory=${value.name}`
    });
    this.setState({
      step: 3,
      ...(!!type && { type }),
      ...(!!categoryList && { categoryList }),
      category: value.name,
      stepMedicine: 1,
      showNewMutual: false,
      mutual: { amount: '', file: null },
      remboursement: '48'
    });
  };

  selectFile = (e) => {
    this.setState({ files: e, sendDocumentErrors: [] }, () => {
      if (this.state.files.length !== 0) {
        this.validateFileUpload();
      }
    });
  };

  onChange = (e) => {
    this.setState({ description: e.target.value }, this.validateDescription);
  };

  validateFileUpload = () => {
    if (!this.state.files.length) {
      this.setState({
        isUploadValid: false
      });
    } else {
      this.setState({
        isUploadValid: true
      });
    }
  };
  validateDescription = () => {
    if (this.state.description.length < 0) {
      this.setState({
        isDescriptionValid: false
      });
    } else {
      this.setState({
        isDescriptionValid: true
      });
    }
  };

  validate = () => {
    this.validateFileUpload();
    this.validateDescription();
    return this.state.files.length;
  };

  onSubmit = async () => {
    if (this.validate()) {
      this.setState({ sendDocumentErrors: [] });
      const res = await this.sendDocument();
      if (res?.status === 200) {
        this.setState({
          step: 4
        });
      } else {
        this.setState({ sendDocumentErrors: getApiErrorMessages(res) });
      }
    }
  };

  sendDocument = async () => {
    const {
      type,
      category,
      medicine,
      description,
      files,
      mutual,
      categoryList,
      selectedSeuil
    } = this.state;
    const data = new FormData();
    const isMedecineDouce = category.toLowerCase() === BANETTE.MEDECINE_DOUCE;
    const isCatJustificatifMaintienEnfant =
      type.categoryName.toLowerCase() === BANETTE.JUSTIFICATIF_MAINTIEN_ENFANT;

    // Ajouter les données de base
    data.append('Category.Name', type.name);
    data.append('CategoryId', type.id);
    data.append('Category.Id', type.id);
    data.append('Category.Type', category);

    // Ajouter le commentaire et données personalisées
    let commentaire;
    if (isMedecineDouce) {
      commentaire = createMedecineDouceComment(
        this.state.medicine,
        this.state.description,
        this.state.mutual
      );
    } else if (isCatJustificatifMaintienEnfant) {
      commentaire = createJustificatifMaintienComment(
        this.state.enfant,
        description
      );

      //Si situation de l'enfant =En  étude,
      // et type de documents = avis d'imposition + certificat de scolarité, alors c'est true.
      data.append(
        'CertificateInfo.IsChildStatusStudying',
        this.state.enfant.situation.idDocToSend === 0 &&
          (this.state.enfant.typedoc?.idDocToSend ??
            this.state.enfant.situation.idDocToSend) === 0
      );

      data.append(
        'CertificateInfo.DocumentType',
        this.state.enfant.typedoc?.idDocToSend ??
          this.state.enfant.situation.idDocToSend
      ); //id type doc

      data.append('CertificateInfo.Year', this.state.enfant.schoolYear); //année

      data.append(
        'CertificateInfo.Beneficiary.FirstName',
        this.state.enfant.benefitaire.firstName
      );

      data.append(
        'CertificateInfo.Beneficiary.LastName',
        this.state.enfant.benefitaire.lastName
      );

      data.append(
        'CertificateInfo.Beneficiary.CodeAdherent',
        this.state.enfant.benefitaire.codeAdherent
      );
    } else {
      commentaire = description;
    }
    data.append('Comment', commentaire);

    // Ajouter les fichiers
    files.forEach((file) => data.append('Files', file));
    if (isMedecineDouce && mutual.file) {
      data.append('Files', mutual.file);
    }

    // Trouver la catégorie
    const typeCategory = categoryList?.find(
      (cat) => cat.categoryName === category
    );

    // Préparer les données pour l'API
    const processedData = {
      categoryId: typeCategory?.parentCategoryId || this.state.type.id,
      subCategoryId: typeCategory?.categoryId || this.state.type.id,
      isSeuilSuperior: selectedSeuil === 2
    };

    if (isCatJustificatifMaintienEnfant) {
      return await apiPostSendDocumentCertificates(data, processedData);
    } else {
      return await apiPostNewSendDocument(data, processedData);
    }
  };

  onChangeMedicine = (value, key) => {
    const aux = { ...this.state.medicine };
    if (key == 'date') {
      aux[key] = new Date(value);
    } else if (key == 'code' || key == 'amount') {
      if (isNumber(value) || value == '') {
        aux[key] = value;
      }
    } else {
      aux[key] = value;
    }
    this.setState({ medicine: aux });
  };

  medicineStep = (step) => {
    this.setState({
      stepMedicine: step
    });
  };

  openNewMutual = () => {
    this.setState({
      showNewMutual: true
    });
  };

  onChangeMutual = (value, key) => {
    const aux = { ...this.state.mutual };
    aux[key] = value;
    this.setState({ mutual: aux });
  };

  onChangeSelectJustificatifMaintienEnfant = (event, field) => {
    const { value } = event.target;

    this.setState((prevState) => ({
      enfant: {
        ...prevState.enfant,
        [field]: value
      }
    }));
  };

  render() {
    return (
      <SendDocumentTemplate
        state={this.state}
        onReturn={this.onReturn}
        selectElement={this.selectElement}
        selectCategory={this.selectCategory}
        selectFile={this.selectFile}
        onChange={this.onChange}
        onSubmit={this.onSubmit}
        onChangeMedicine={this.onChangeMedicine}
        onChangeSelect={this.onChangeSelectJustificatifMaintienEnfant}
        medicineStep={this.medicineStep}
        openNewMutual={this.openNewMutual}
        onChangeMutual={this.onChangeMutual}
        onSelectSeuil={this.onSelectSeuil}
      />
    );
  }
}
SendDocument.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};
export default SendDocument;
